export default "__VITE_ASSET__CcyohgLC__"